/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Presentation page sections
import Testimonials from "pages/Presentation/sections/Testimonials";

// Presentation page components
import ExampleCard from "pages/Presentation/components/ExampleCard";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

import data from "pages/Presentation/sections/data/TenueData";

import { Link } from "react-router-dom";

function RealisationTenue() {
  const renderData = data.map(({ title, description, items }) => (
    <Grid container spacing={3} sx={{ mb: 10 }} key={title}>
      <Grid item xs={12} lg={3}>
        <MKBox position="sticky" top="100px" pb={{ xs: 2, lg: 6 }}>
          <MKTypography variant="h3" fontWeight="bold" mb={1} sx={{ color: "#1d910eff" }}>
            {title}
          </MKTypography>
          <MKTypography variant="body2" fontWeight="regular" color="secondary" mb={1} pr={2}>
            {description}
          </MKTypography>
        </MKBox>
      </Grid>
      <Grid item xs={12} lg={9}>
        <Grid container spacing={3}>
          {items.map(({ image, name, count, route, pro }) => (
            <Grid item xs={12} md={6} sx={{ mb: 2 }} key={name}>
              <Link to={route || "/"}>
                <ExampleCard image={image} name={name} count={count} pro={pro} />
              </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  ));

  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" my={5} py={5} mt={10}>
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={6}
              flexDirection="column"
              alignItems="center"
              sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKBadge
                variant="contained"
                color="info"
                badgeContent="REALISATIONS"
                container
                sx={{ mb: 2 }}
              />
              <MKTypography variant="h2" fontWeight="bold" sx={{ color: "#1d910eff" }}>
                Nos differentes réalisations
              </MKTypography>
              <MKTypography variant="body1" color="text">
                ANEMAR GROUPE vous presente quelques unes de ses réalisations concernant la tenue
                traditionnelle et soirée.
              </MKTypography>
            </Grid>
          </Container>
          <Container sx={{ mt: 6 }}>{renderData}</Container>
        </MKBox>
        <div id="contacts">
          <Testimonials />
        </div>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default RealisationTenue;
